import React from 'react';

import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';

import { PanelAction } from '../../panel-action/panel-action';
import type { PanelActionProps } from '../../panel-action/types';

export interface PanelActionBackProps extends Pick<
	PanelActionProps,
	'onClick' | 'testId' | 'label'
> {}

/**
 * The PanelActionBack component provides a back action button
 * for navigating back to the previous view in panels.
 */
export const PanelActionBack: React.ForwardRefExoticComponent<
	PanelActionBackProps & React.RefAttributes<HTMLButtonElement>
> = React.forwardRef<HTMLButtonElement, PanelActionBackProps>(({ onClick, testId, label }, ref) => {
	return (
		<PanelAction
			ref={ref}
			onClick={onClick}
			testId={testId}
			spacing="compact"
			icon={ArrowLeftIcon}
			label={label || 'Go back'}
		/>
	);
});

PanelActionBack.displayName = 'PanelActionBack';
